export const hotGossipList = [
  {
    id: 1,
    title: "某千万粉丝女主播被曝私下与榜一大哥约会，聊天记录曝光",
    excerpt: "近日有知情人士爆料，某平台拥有千万粉丝的女主播私下频繁与多位榜一大哥约会，相关聊天记录及照片已在社交平台疯传。事件涉及金额高达数百万元，引发网友热议。",
    image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20shadowy%20figure%20silhouette%20holding%20phone%2C%20dramatic%20lighting%20from%20side%2C%20low%20key%20photography%20style%2C%20noir%20aesthetic%2C%20deep%20shadows%2C%20cinematic%20composition%2C%20moody%20and%20suspenseful%20tone%2C%20dark%20background%20with%20subtle%20red%20accent%20light%2C%20editorial%20photography&width=600&height=700&seq=gossip-hot-01&orientation=squarish",
    category: "网红黑料",
    date: "2026-07-06",
    views: 1289300,
    slug: "female-streamer-scandal-exposed"
  },
  {
    id: 2,
    title: "知名男星深夜密会神秘女子，疑似婚内出轨证据确凿",
    excerpt: "有媒体拍到某一线男星深夜与一名神秘女子在某高档酒店共处近六小时，次日清晨独自离开。多名知情人士证实该男星确实存在婚内出轨行为，更多细节正在追踪中。",
    image: "https://readdy.ai/api/search-image?query=Dark%20alley%20at%20night%20with%20two%20blurred%20silhouettes%20walking%20apart%2C%20street%20lamp%20casting%20dramatic%20shadows%2C%20noir%20cinematic%20style%2C%20mysterious%20urban%20night%20scene%2C%20low%20key%20lighting%2C%20dark%20moody%20atmosphere%2C%20film%20grain%20texture%2C%20deep%20blacks&width=600&height=700&seq=gossip-hot-02&orientation=squarish",
    category: "明星八卦",
    date: "2026-07-05",
    views: 2156700,
    slug: "male-celebrity-cheating-scandal"
  },
  {
    id: 3,
    title: "网红情侣分手内幕：财产纠纷升级，女方晒出转账记录",
    excerpt: "一对拥有数百万粉丝的网红情侣突然宣布分手，随后女方在社交平台晒出大量转账记录和聊天截图，控诉男方存在欺骗行为。事件持续发酵，双方粉丝展开激烈争论。",
    image: "https://readdy.ai/api/search-image?query=Cracked%20heart%20shape%20made%20of%20glass%20fragments%20on%20dark%20surface%2C%20dramatic%20side%20lighting%2C%20split%20composition%20left%20warm%20right%20cold%2C%20emotional%20tension%2C%20dark%20atmospheric%20background%2C%20cinematic%20moody%20photography%2C%20conceptual%20breakup%20symbolism&width=600&height=700&seq=gossip-hot-03&orientation=squarish",
    category: "网红黑料",
    date: "2026-07-04",
    views: 1892300,
    slug: "influencer-couple-breakup-drama"
  },
  {
    id: 4,
    title: "某综艺节目录制现场突发冲突，两位导师当场翻脸",
    excerpt: "据现场观众爆料，某热门综艺节目最新一期录制过程中，两位常驻导师因选手评分问题发生激烈争执，甚至出现肢体冲突。节目组已紧急叫停录制，后续处理仍在协商中。",
    image: "https://readdy.ai/api/search-image?query=Two%20figures%20facing%20each%20other%20in%20confrontation%20pose%20on%20dark%20stage%2C%20spotlight%20from%20above%20creating%20dramatic%20shadows%2C%20tension%20and%20conflict%20atmosphere%2C%20theatrical%20lighting%2C%20dark%20background%2C%20cinematic%20composition%2C%20low%20key%20photography&width=600&height=700&seq=gossip-hot-04&orientation=squarish",
    category: "明星八卦",
    date: "2026-07-03",
    views: 3451200,
    slug: "variety-show-fight-incident"
  }
];

export const featuredChannels = [
  {
    id: 1,
    title: "网红黑料",
    description: "追踪全网网红不为人知的另一面，独家爆料网红圈内幕，吃瓜第一线。涵盖短视频、直播、电商等各领域网红真实黑料。",
    icon: "ri-user-search-line",
    slug: "wanghong-heiliao",
    color: "primary"
  },
  {
    id: 2,
    title: "明星八卦",
    description: "娱乐圈最新最热的明星八卦资讯，影视歌三栖明星动态一手掌握。从恋情曝光到事业风波，不错过任何一个瓜。",
    icon: "ri-star-line",
    slug: "mingxing-bagua",
    color: "accent"
  },
  {
    id: 3,
    title: "社会奇闻",
    description: "大千世界无奇不有，每日精选社会热点奇闻异事。聚焦民生百态，深度挖掘不为人知的社会现象与离奇事件。",
    icon: "ri-global-line",
    slug: "shehui-qiwen",
    color: "secondary"
  }
];

export const latestArticles = [
  {
    id: 5,
    title: "电竞圈大地震：知名职业选手涉嫌假赛被联盟调查",
    excerpt: "多名职业选手被曝参与外围赌博操控比赛结果，电竞联盟已成立专项调查组。涉及多支顶级战队，行业信誉面临严峻考验。",
    image: "https://readdy.ai/api/search-image?query=Dark%20esports%20arena%20with%20empty%20gaming%20chairs%20and%20dim%20monitors%2C%20dramatic%20spotlight%20on%20center%20stage%2C%20investigative%20atmosphere%2C%20dark%20blue%20and%20red%20accent%20lighting%2C%20cinematic%20wide%20shot%2C%20mysterious%20competitive%20gaming%20scene&width=800&height=500&seq=article-esports-01&orientation=landscape",
    category: "网红黑料",
    date: "2026-07-02",
    views: 978500,
    slug: "esports-match-fixing-scandal"
  },
  {
    id: 6,
    title: "某女星整容前后对比照曝光，网友直呼认不出",
    excerpt: "一组某知名女星的素颜街拍照片在网络上疯传，网友将其与早期作品中的形象对比，发现变化巨大，引发关于整容的激烈讨论。",
    image: "https://readdy.ai/api/search-image?query=Split%20face%20concept%20with%20half%20in%20shadow%20half%20in%20light%2C%20before%20and%20after%20symbolism%2C%20dramatic%20contrast%20lighting%2C%20dark%20elegant%20background%2C%20mysterious%20portrait%20composition%2C%20editorial%20fashion%20photography%20style&width=800&height=500&seq=article-plastic-01&orientation=landscape",
    category: "明星八卦",
    date: "2026-07-01",
    views: 1567800,
    slug: "actress-plastic-surgery-exposed"
  },
  {
    id: 7,
    title: "某城市深夜发生离奇事件，监控拍下全过程",
    excerpt: "一段深夜监控视频在社交媒体引发广泛关注，视频中出现的异常现象令网友议论纷纷。当地警方已介入调查，具体情况有待官方通报。",
    image: "https://readdy.ai/api/search-image?query=Dark%20empty%20street%20at%203am%20with%20fog%2C%20single%20streetlight%20casting%20eerie%20glow%2C%20CCTV%20camera%20visible%20on%20pole%2C%20mysterious%20urban%20night%20atmosphere%2C%20cinematic%20horror%20aesthetic%2C%20deep%20shadows%2C%20greenish%20tint%20from%20security%20light&width=800&height=500&seq=article-mystery-01&orientation=landscape",
    category: "社会奇闻",
    date: "2026-06-30",
    views: 2345600,
    slug: "midnight-mystery-cctv-footage"
  },
  {
    id: 8,
    title: "知名带货主播被指虚假宣传，消费者集体维权",
    excerpt: "某头部带货主播因涉嫌虚假宣传被消费者集体投诉，涉及商品质量问题及夸大功效。目前已有上千名消费者联名维权，相关部门已立案调查。",
    image: "https://readdy.ai/api/search-image?query=Dark%20studio%20with%20empty%20livestream%20setup%2C%20ring%20light%20and%20product%20display%20on%20desk%2C%20dramatic%20backlight%2C%20controversial%20atmosphere%2C%20investigative%20journalism%20style%2C%20moody%20lighting%2C%20professional%20streaming%20equipment%20in%20shadow&width=800&height=500&seq=article-livestream-01&orientation=landscape",
    category: "网红黑料",
    date: "2026-06-29",
    views: 1890200,
    slug: "livestream-false-advertising"
  },
  {
    id: 9,
    title: "某富二代深夜飙车被拘，车内搜出大量违禁物品",
    excerpt: "警方深夜在市中心拦截一辆超速行驶的豪车，驾驶者为某知名企业家的儿子。警方在车内搜出违禁物品，目前嫌疑人已被刑事拘留。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20sports%20car%20parked%20on%20dark%20wet%20street%20at%20night%2C%20police%20lights%20reflecting%20on%20surface%2C%20dramatic%20blue%20and%20red%20flashing%20lights%2C%20urban%20night%20scene%2C%20cinematic%20crime%20scene%20aesthetic%2C%20moody%20atmosphere&width=800&height=500&seq=article-racing-01&orientation=landscape",
    category: "社会奇闻",
    date: "2026-06-28",
    views: 4123000,
    slug: "rich-kid-street-racing-arrest"
  },
  {
    id: 10,
    title: "某剧组拍摄现场发生意外，演员受伤送医",
    excerpt: "某大型古装剧拍摄现场突发意外事故，威亚设备出现故障导致一名主演从高处坠落。伤者已被紧急送医，剧组现已暂停所有拍摄工作配合调查。",
    image: "https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20equipment%20and%20rigging%20in%20darkness%2C%20spotlight%20on%20empty%20scene%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20suspended%20cables%20and%20lights%2C%20cinematic%20composition%2C%20moody%20backstage%20photography&width=800&height=500&seq=article-film-01&orientation=landscape",
    category: "明星八卦",
    date: "2026-06-27",
    views: 1678900,
    slug: "film-set-accident-injury"
  }
];